module.exports = __webpack_public_path__ + "static/2trees-0a43122b265faf77c5d1120db142edce.png";